/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon64Regular = forwardRef('ArrowDim1VIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M30.5 7.656a2.53 2.53 0 0 0-.268.233L19.561 18.56a1.5 1.5 0 0 1-2.122-2.12L28.111 5.767a5.5 5.5 0 0 1 7.778 0l10.672 10.671a1.5 1.5 0 0 1-2.122 2.122L33.768 7.889a2.522 2.522 0 0 0-.268-.233v48.688c.093-.07.183-.148.268-.233l10.671-10.672a1.5 1.5 0 0 1 2.122 2.121L35.889 58.233a5.5 5.5 0 0 1-7.778 0L17.439 47.56a1.5 1.5 0 0 1 2.122-2.12l10.671 10.67c.085.086.175.163.268.233V7.656Z" })));
});
